import { sharedLib } from "@shared/services/shared.service";
import { sumBy } from "lodash";
import { useMemo } from "react";
import { useTheme } from "styled-components";

const useUsageChart = () => {
  const theme = useTheme();
  const { data: tradeUsageChartData, isLoading } =
    sharedLib.sharedApi.settings.useGetTradeUsageChartQuery(undefined, {
      refetchOnMountOrArgChange: true,
    });

  const legends = ["opened", "missed"];
  const backgroundColors = [theme.colors.primaryBlue, theme.colors.primaryGrey];

  const data = (tradeUsageChartData || []).map((dataPoint) => dataPoint[1]);

  const [numOpened, numMissed] = useMemo(() => {
    return [sumBy(data, (point) => point[0]), sumBy(data, (point) => point[1])];
  }, [data]);

  return {
    theme,
    tradeUsageChartData,
    isLoading,
    numOpened,
    numMissed,
    legends,
    backgroundColors,
    data,
  };
};

export default useUsageChart;
